import { render, staticRenderFns } from "./ContactNew.vue?vue&type=template&id=7a6f8b3a&"
import script from "./ContactNew.vue?vue&type=script&lang=js&"
export * from "./ContactNew.vue?vue&type=script&lang=js&"
import style0 from "./ContactNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports